export default "__VITE_ASSET__CqcqIkBr__"